<app-list-loading [items]="linkedResources">
    <div class="overflow-hidden rounded-2xl border border-slate-200 bg-white">
        <div class="table-responsive">
            <table>
                <thead>
                    <tr>
                        <th>{{ 'translate_name' | translate }}</th>
                        <th>{{ 'translate_resource_type' | translate }}</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    @for (resource of linkedResources; track resource) {
                        <tr>
                            <td>{{ resource.name }}</td>
                            <td class="text-center">
                                <span
                                    class="inline-flex items-center rounded-full bg-blue-50 px-2.5 py-1 text-xs font-medium text-blue-700"
                                >
                                    {{
                                        resource.type
                                            | translateItem: 'resource-type'
                                            | async
                                    }}
                                </span>
                            </td>
                            <td class="text-center">
                                @if (resourcesLinks.get(resource.id)) {
                                    <a
                                        [routerLink]="
                                            resourcesLinks.get(resource.id)
                                        "
                                        [queryParams]="
                                            resourcesLinksQueryParams.get(
                                                resource.id
                                            )
                                        "
                                        target="_blank"
                                        class="action-icon action-icon-view"
                                        [appTooltip]="
                                            'translate_view' | translate
                                        "
                                    >
                                        <i
                                            class="fa-light fa-up-right-from-square"
                                        ></i>
                                    </a>
                                }
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    </div>
</app-list-loading>
